import { render, staticRenderFns } from "./SingleRepair.vue?vue&type=template&id=4e850480&scoped=true"
import script from "./SingleRepair.vue?vue&type=script&lang=js"
export * from "./SingleRepair.vue?vue&type=script&lang=js"
import style0 from "./SingleRepair.vue?vue&type=style&index=0&id=4e850480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e850480",
  null
  
)

export default component.exports